import React, {useCallback, useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import HeaderComponent from "../../shared/components/layout/header/HeaderComponent";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../store/reducers";
import {CommonService} from "../../shared/services";
import ButtonComponent from "../../shared/components/button/ButtonComponent";
import {ImageConfig, Misc} from "../../constants";
import {IAPIResponseType} from "../../shared/models/api.model";
import {setLoggedInUserData, setLoggedInUserToken} from "../../store/actions/account.action";
import LinkComponent from "../../shared/components/link/LinkComponent";

export interface AppLayoutProps {

}

const AppLayout = (props: AppLayoutProps) => {
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const navigate = useNavigate();
    const location = useLocation();
    const [showViewDetails, setShowViewDetails] = useState<boolean>(true)
    const dispatch = useDispatch();
    const bookAppointmentPathSegments = location?.pathname;

    const navigateToProfileDetails = useCallback(() => {
        navigate(CommonService._routeConfig.ProfileLayout());
    }, [navigate]);

    useEffect(() => {
        if (location.pathname.match(CommonService._routeConfig.ProfileDetails()) || location.pathname.match(CommonService._routeConfig.ProfileLinking())) {
            setShowViewDetails(false);
        } else {
            setShowViewDetails(true);
        }
    }, [location.pathname]);

    const exitProfile = useCallback(() => {
        const payload = {}
        CommonService._account.exitProfile(payload)
            .then((response: IAPIResponseType<any>) => {
                window.location.href = CommonService._routeConfig.Dashboard();
                dispatch(setLoggedInUserData(response?.data?.user));
                dispatch(setLoggedInUserToken(response?.data?.token));
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
            })
            .catch((error: any) => {
            });
    }, [dispatch]);

    return (
        <>

            {bookAppointmentPathSegments === "/book-appointment" && <>
                <div className={"book-appointment-app-layout"}>
                    <div className="book-appointment-content-container">
                        <Outlet/>
                    </div>
                </div>
            </>
            }

            {/*Regular Flow*/}
            {bookAppointmentPathSegments !== "/book-appointment" && <>
                <div className="app-layout">
                    <div className="header-container">
                        <HeaderComponent showProfileDropdown={currentUser?.profile_viewing_as?.client_id}/>
                    </div>
                    {currentUser && Object.keys(currentUser.profile_viewing_as).length > 0 &&
                        <div className="exist-profile-layout">
                            <div className="exist-profile-content-wrapper">
                                <div className="exist-profile-content">
                                    <div> You are currently
                                        using <b>{currentUser?.profile_viewing_as?.first_name} {currentUser?.profile_viewing_as?.last_name}'s </b>(ID: {currentUser.profile_viewing_as?.client_id})
                                        profile.
                                    </div>
                                    {showViewDetails &&
                                        <LinkComponent className="pdd-left-10" onClick={navigateToProfileDetails}>(View
                                            Account
                                            Settings)</LinkComponent>}
                                </div>
                                <ButtonComponent
                                    color={'accent'}
                                    size={'small'}
                                    className={'exit-profile-cta'}
                                    onClick={() => exitProfile()}
                                    prefixIcon={<ImageConfig.ExitIcon/>}>
                                    Exit Profile
                                </ButtonComponent>
                            </div>
                        </div>
                    }
                    <div className="content-container">
                        <Outlet/>
                    </div>
                </div>
            </>
            }
        </>
    );
}


export default AppLayout;




